module.exports = __webpack_public_path__ + "img/logo-bakalavriat.0967f481.svg";